import "phaser";
import { Game } from "./Game";
import { GameConstants } from "./GameConstants";
import { BootScene } from "./scenes/BootScene";
import { PreloadScene } from "./scenes/PreloadScene";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { SplashScene } from "./scenes/splash-scene/SplashScene";
import { ShopScene } from "./scenes/shop/ShopScene";
import { TutorialScene } from "./scenes/tutorial-scene/TutorialScene";

let game: Game;

window.onload = () => {

    const gameConfig = {

        type: Phaser.AUTO,
        backgroundColor: "CCCCCC",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameConstants.GAME_WIDTH,
            height: GameConstants.GAME_HEIGHT
        },
        scene:  [
                    BootScene, 
                    PreloadScene, 
                    SplashScene,
                    ShopScene,
                    TutorialScene,
                    BoardScene
                ]
    };

    // If compilation error here, compare Phaser definitions file of working copy (phaser.d.ts, line 48040 on 27-05-2019)
    // Also make sure to delete all *.ts files in node_modules/trailz folder
    game = new Game(gameConfig);

    window.focus();

    window.addEventListener("orientationchange", checkOriention, false);
};

function checkOriention(): void {

    setTimeout(function() { 

        const w = window.innerWidth;
        const h = window.innerHeight;
    
        if (h > w) {
    
            if (!GameVars.intitialised) {
                
                GameManager.init(); 
            }
    
            document.getElementById("orientation").style.display = "none";
            document.getElementById("content").style.display = "block";
        } else {
            document.getElementById("orientation").style.display = "block";
            document.getElementById("content").style.display = "none";
        }
    }, 300);
}
